import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { PnpImporterPage } from '@/areas/pick-and-place/common/PickAndPlaceImporterPage';
import { useCanViewPnp } from '@/shared/permissions/featureFlags';
import { NotAuthorizedPage } from '@/shared/permissions/NotAuthorizedPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pnp-importer')({
    staticData: {
        // The page checks for itself (`useCanViewPnp`): whether a customer may open it is a customer portal setting,
        // which the session doesn't load. PnP edits are gated by `isRfqEditable`.
        access: 'authenticated',
        chrome: 'project',
    } satisfies PageStaticData,
    validateSearch: stringSearch({ currentParentAssemblyId: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const currentParentAssemblyId = Route.useSearch({ select: (search) => search.currentParentAssemblyId });
    const { canViewPnp } = useCanViewPnp();
    if (!canViewPnp) {
        return <NotAuthorizedPage />;
    }
    return <PnpImporterPage {...pathParams} currentParentAssemblyId={currentParentAssemblyId} />;
}
